import React, { useState } from "react";

import EditEmployeeModal from "EmployerApplication/Components/EditEmployeeModal";
import AnalyticsTracking from "Utils/AnalyticsTracking";
import { canEdit } from "Utils/canEdit";
import { compareByEmail } from "Utils/comparisons";

import { MenuDropdown, Option } from "Cobalt/Dropdown";
import { StandaloneTrigger } from "Cobalt/Modal";
import { Table, HeaderTR, TH, TR, TD, EllipsisTD, SnugTD } from "Cobalt/TableV2";
import Icon from "Common/Icon";
import InfoPopover from "Common/InfoPopover";

import type { AddEmployeeRow } from "EmployerApplication/createStore";

import makeBem from "Utils/makeBem";

const bem = makeBem("EmployeeTable");

const EditButtons = ({ employee, disableRemove, handleClickDeleteEmployee }) => (
  <>
    <StandaloneTrigger
      employee={employee}
      trigger={(props) => (
        <Option
          aria-label="Edit Employee"
          onClick={(e) => {
            props.onClick(e);
          }}
        >
          <Icon icon="pencil-alt" flavor="solid" mr={3} />
          Edit
        </Option>
      )}
      modal={(props) => <EditEmployeeModal form={`editEmployeeForm_${employee.hash_id}`} {...props} />}
    />

    <Option className={bem(null, "red")} onClick={() => handleClickDeleteEmployee()} aria-label="Remove Employee">
      {disableRemove[employee.hash_id] ? (
        <>
          <Icon icon="cog" mr={3} spin flavor="solid" />
          Loading...
        </>
      ) : (
        <>
          <Icon icon="trash" mr={3} />
          Remove
        </>
      )}
    </Option>
  </>
);

type Props = {
  onDeleteEmployee: (arg0: string) => void;
  employees: Array<AddEmployeeRow>;
};

export const EmployeeTableDumb = ({ employees, onDeleteEmployee }: Props) => {
  const [disableRemove, setDisableRemove] = useState({});

  const handleClickDeleteEmployee = (hashId: string) => {
    AnalyticsTracking.trackEvent("cta_clicked", {
      location: "add_employee",
      label: "remove",
    });

    onDeleteEmployee(hashId);
    setDisableRemove({ ...disableRemove, [hashId]: true });
  };

  return (
    <Table aria-label="Employee Table">
      {employees.length == 0 && (
        <tbody>
          <tr>
            <td>No employees added yet!</td>
          </tr>
        </tbody>
      )}

      <thead>
        <HeaderTR>
          <TH width="200px">Employee</TH>
          <TH>Email</TH>
          <TH />
        </HeaderTR>
      </thead>
      <tbody>
        {employees.sort(compareByEmail).map(
          (employee) =>
            employee.is_eligible && (
              <TR key={employee.hash_id}>
                <EllipsisTD min-width="150px">{employee.full_name}</EllipsisTD>
                <TD>{employee.email ? employee.email : "--"}</TD>
                <SnugTD>
                  {canEdit(employee) ? (
                    <MenuDropdown pullRight>
                      <EditButtons
                        employee={employee}
                        disableRemove={disableRemove}
                        handleClickDeleteEmployee={() => handleClickDeleteEmployee(employee.hash_id)}
                      />
                    </MenuDropdown>
                  ) : (
                    <InfoPopover
                      infoText="If you want to edit this employee, you need do that using QuickBooks Payroll."
                      displayComponent={<Icon icon="info-circle" />}
                    />
                  )}
                </SnugTD>
              </TR>
            ),
        )}
      </tbody>
    </Table>
  );
};

export default EmployeeTableDumb;
